import React from "react";
import logo from "../images/nz-transport-agency-logo.png";
import styles from "./DriverConsent.module.scss";

const DriverConsetSecondPage = () => {
    return (
        <div className="container">
            <div className={`${styles.secondPage}`}>
                <div className="row">
                    <div className="col-sm-4 text-left">
                        <img src={logo} alt="Logo" />
                    </div>
                    <div className="col-sm-8 text-right">
                        <h1>Important information about giving consent to</h1>
                        <h1>access your information in Driver Check</h1>
                </div>
            </div>
            </div>
            {/* About Driver Check Section */}
            <div className="section-content" >
                <div className={styles.sectionHeader}>About Driver Check</div>
                <p>Driver Check is a safe and secure website set up by NZTA. It lets companies make sure they only have appropriately-licensed drivers driving their company vehicles.</p>
            </div>

            {/* Information that can be released Section */}
            <div className="section-content" >
                <div className={styles.sectionHeader}>Information that can be released through Driver Check</div>
                <p>Driver Check lets the company or service provider you work for (usually a nominated staff member) see the:</p>
                <ul>
                    <li>licence classes you hold (eg a class 4 licence to drive heavy trucks)</li>
                    <li>licence endorsements you hold (eg a D endorsement to carry dangerous goods)</li>
                    <li>conditions on your licence (eg if you have to wear glasses or contact lenses while driving)</li>
                    <li>status of your licence (eg current, expired, limited, suspended, disqualified, revoked or reinstated)</li>
                </ul>
                <p>If you’re added to the driver list for this company, NZTA will automatically let them know if any of the above information about your driver licence changes.</p>
                <p>The company can only access Driver Check if they’ve agreed to NZTA’s terms and conditions. Those terms and conditions include meeting the requirements in the Privacy Act 2020. If the company doesn’t meet the terms and conditions, they could have their Driver Check access removed.</p>
            </div>

            {/* Getting your consent Section */}
            <div className="section-content" >
                <div className={styles.sectionHeader}>Getting your consent</div>
                <p>To get your information from Driver Check the company must:</p>
                <ul>
                    <li>have your written consent before they access your licence record</li>
                    <li>keep a copy of that written consent</li>
                    <li>give you a copy of that written consent if you ask for it</li>
                    <li>give a copy of that written consent to NZTA if we ask for it for auditing purposes</li>
                    <li>have your permission before releasing any information gathered through Driver Check to any third party</li>
                </ul>
            </div>

            {/* Withdrawing your consent Section */}
            <div className="section-content" >
                <div className={styles.sectionHeader}>Withdrawing your consent</div>
                <p>By signing this form, you’ll be agreeing to the information listed above being released to the company or person you name.</p>
                <p>You may, at any time, withdraw your consent for a company to access your driver licence information through Driver Check.</p>
                <p>To withdraw your consent:</p>
                <ul>
                    <li>you must tell the company you want to be removed from their Driver Check list (it’s best to do it in writing)</li>
                    <li>you can also contact <a href="mailto:driver.check@nzta.govt.nz">driver.check@nzta.govt.nz</a> and tell NZTA that you’d like to be removed from the company’s Driver Check access.</li>
                </ul>
                <p>Please be aware that NZTA will contact the company and let them know that you’ve asked to withdraw your consent.</p>
            </div>

            {/* Your privacy Section */}
            <div className="section-content" >
                <div className={styles.sectionHeader}>Your privacy</div>
                <p>The company using the Driver Check service must meet the requirements in the Privacy Act 2020. In particular, they must follow the information privacy principles set out under section 22. If you have any questions or concerns about your privacy, contact the company using the Driver Check service or find more information on the Privacy Commissioner’s website at <a href="https://www.privacy.org.nz" target="_blank" rel="noopener noreferrer">www.privacy.org.nz</a>.</p>
                <p>NZTA is also required by law to keep certain personal information from the Driver Licence Register available on inquiry to members of the public under section 199 of the Land Transport Act 1998.</p>
                <p>If you have any questions about the information NZTA holds about you, please email <a href="mailto:info@nzta.govt.nz">info@nzta.govt.nz</a>.</p>
            </div>
        </div>
    );
};

export default DriverConsetSecondPage;